<template>
<div>

    <div class="rentals-list-w" v-if="wrapper">
        <div class="rentals-list">
            <div class="pagination-w">
                <div class="pagination-info">SHOWING {{pagination.from}}-{{pagination.to}} OF {{pagination.total}} RECORDS</div>
                <div class="pagination-links">
                    <ul class="pagination">
                        <li class="page-item" :class="(pagination.current_page <= 1 ? 'disabled' : '')"><a class="page-link" @click.prevent="changePage(pagination.current_page - 1)"> Previous</a></li>

                            <li v-for="page in pages" class="page-item" :class="isCurrentPage(page) ? 'active' : ''"><a class="page-link"  @click.prevent="changePage(page)">{{page}}</a></li>

                        <li class="page-item" :class="(pagination.current_page >= pagination.last_page ? 'disabled' : '')"><a class="page-link" @click.prevent="changePage(pagination.current_page + 1)"> Next</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="pagination-w" v-else>
        <div class="pagination-info">SHOWING {{pagination.from}}-{{pagination.to}} OF {{pagination.total}} RECORDS</div>
        <div class="pagination-links">
            <ul class="pagination">
                <li class="page-item" :class="(pagination.current_page <= 1 ? 'disabled' : '')"><a class="page-link" @click.prevent="changePage(pagination.current_page - 1)"> Previous</a></li>

                    <li v-for="page in pages" class="page-item" :class="isCurrentPage(page) ? 'active' : ''"><a class="page-link"  @click.prevent="changePage(page)">{{page}}</a></li>

                <li class="page-item" :class="(pagination.current_page >= pagination.last_page ? 'disabled' : '')"><a class="page-link" @click.prevent="changePage(pagination.current_page + 1)"> Next</a></li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
export default {
  props: ['pagination', 'offset', 'withWrapper'],
  data: function () {
    return {
      wrapper: true
    }
  },
  methods: {
    isCurrentPage (page) {
      return this.pagination.current_page === page
    },
    changePage (page) {
      if (page > this.pagination.last_page) {
        page = this.pagination.last_page
      }
      this.pagination.current_page = page
      this.$emit('paginate')
    }
  },
  computed: {
    pages () {
      let pages = []
      let from = this.pagination.current_page - Math.floor(this.offset / 2)
      if (from < 1) {
        from = 1
      }
      let to = from + this.offset - 1
      if (to > this.pagination.last_page) {
        to = this.pagination.last_page
      }
      while (from <= to) {
        pages.push(from)
        from++
      }
      return pages
    }
  },
  watch: {
    withWrapper () {
      this.wrapper = this.withWrapper
    }
  }
}
</script>
